import { motion } from "framer-motion";
import { Cross, Globe, ScrollText, Users } from "lucide-react";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

const GOVERNO_ITEMS = [
  {
    icon: Cross,
    testid: "governo-item-primaz",
    title: "Arcebispo Primaz",
    text: "O Arcebispo Primaz é a autoridade máxima da Diocese e preside sua unidade e governo.",
  },
  {
    icon: Users,
    testid: "governo-item-prelados",
    title: "Bispos Prelados",
    text: "Cada Prelazia possui um Bispo Prelado, que representa episcopal e pastoralmente a Diocese e a Sé Primacial em sua circunscrição e atua em comunhão e colegialidade com o Arcebispo Primaz. As Prelazias são circunscrições da única Diocese nacional — não são dioceses independentes.",
  },
  {
    icon: ScrollText,
    testid: "governo-item-sinodo",
    title: "Santo Sínodo",
    text: "O Santo Sínodo é a estrutura de comunhão, governo, discernimento e deliberação da Diocese.",
  },
];

export default function Governo() {
  return (
    <section id="governo-episcopal" data-testid="governo-episcopal-section" className="bg-[#2E070D] px-4 py-20 text-[#FBF9F4] sm:px-8 lg:px-16 lg:py-32">
      <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}>
        <motion.p variants={fadeUp} className="overline-label text-[#C5A059]">Governo e Comunhão</motion.p>
        <motion.h2 variants={fadeUp} className="font-display mt-4 text-4xl font-bold uppercase leading-tight sm:text-5xl">
          Governo Episcopal
        </motion.h2>
        <motion.p variants={fadeUp} className="font-liturgy mt-6 max-w-3xl text-xl italic leading-relaxed text-[#FBF9F4]/70">
          A DACB é uma única Diocese, de âmbito nacional, organizada territorialmente em Prelazias —
          governada sob a presidência do Arcebispo Primaz e na colegialidade episcopal dos bispos.
        </motion.p>

        <div className="mt-12 grid gap-6 lg:grid-cols-3">
          {GOVERNO_ITEMS.map((item) => (
            <motion.div
              key={item.testid}
              variants={fadeUp}
              data-testid={item.testid}
              className="group border border-[#C5A059]/25 p-8 transition-colors hover:border-[#C5A059]/60"
            >
              <item.icon className="h-8 w-8 text-[#C5A059]" strokeWidth={1.25} />
              <h3 className="font-display mt-6 text-xl font-bold uppercase tracking-wide">{item.title}</h3>
              <div className="gold-rule mt-4 w-16" />
              <p className="mt-4 text-sm leading-relaxed text-[#FBF9F4]/70">{item.text}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          variants={fadeUp}
          className="mt-14 flex flex-col items-start gap-6 border border-[#C5A059]/40 bg-[#4A0E17]/40 p-8 sm:flex-row sm:items-center sm:justify-between"
        >
          <div>
            <p className="overline-label text-[#C5A059]">Nossa Comunhão Internacional</p>
            <p className="font-display mt-3 max-w-2xl text-2xl font-bold leading-snug">
              A DACB integra a The Anglican Free Communion International — Comunhão Anglicana Livre Internacional.
            </p>
          </div>
          <a
            href="https://anglicanfreecommunion.uk/"
            target="_blank"
            rel="noreferrer"
            data-testid="governo-comunhao-link"
            className="overline-label inline-flex shrink-0 items-center gap-2 bg-[#C5A059] px-6 py-3 text-[#2E070D] transition-colors hover:bg-[#D4AF37]"
          >
            <Globe className="h-4 w-4" /> Site internacional oficial
          </a>
        </motion.div>
      </motion.div>
    </section>
  );
}
